<ng-container>
  @if (gbGemeinde$ | async; as gemeinde) {
    <div>
      @if (!isPublic) {
        <cap-content-header>
          <cap-title>
            <span
              >{{ gemeinde.gemeindeArt | translate }} {{ gemeinde.bfsNummer }}{{ gemeinde.kreisNummer ? "." + gemeinde.kreisNummer : "" }}
              {{ gemeinde?.name | translateName }}</span
            >
          </cap-title>
        </cap-content-header>
      }
      <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrikGbGemeinde">
        <ng-container title>
          <h2 class="mb-0">{{ "Grundbuchgemeinde" | translate }}</h2>
        </ng-container>
        <div class="row mt-2">
          <div class="col-md-6 col-sm-12">
            <cap-kopfdatenelement label="Name">
              {{ gemeinde.name | translateName }}
              @if (
                hasPermissionPlan && planGemeindeModel && planAvailableForGemeindeType && appFormatConfigService.settingsConfig$ | async;
                as settingsConfig
              ) {
                @if (settingsConfig.isMapsLinkConfigured) {
                  <cap-maps
                    [mapType]="'gemeinde'"
                    [model]="planGemeindeModel"
                    [tooltip]="(planGemeindeModel.gemeindeArt | translate) + ' ' + (planGemeindeModel?.name | translateName)"></cap-maps>
                }
              }
            </cap-kopfdatenelement>
            @if (!isPublic) {
              <cap-kopfdatenelement label="kreisNummer">
                @if (gemeinde.kreisNummer) {
                  <span>{{ gemeinde.kreisNummer }}</span>
                }
              </cap-kopfdatenelement>
            }
          </div>
          @if (!isPublic) {
            <div class="col-md-6 col-sm-12">
              <cap-kopfdatenelement label="Art">
                {{ gemeinde.gemeindeArt | translate }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="kuerzel">
                {{ gemeinde.kuerzel }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="gueltig">
                {{ gemeinde.gueltig | yesNo }}
              </cap-kopfdatenelement>
            </div>
          }
        </div>
      </cap-rubrik>
      @if (!isPublic) {
        <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrikPolitischeGemeinde">
          <ng-container title>
            <h2 class="mb-0">
              {{ "gehoertZuFolgenderPolitischerGemeinde" | translate }}
            </h2>
          </ng-container>
          @if (polGemeinde$ | async; as polGemeinde) {
            <div class="row mt-2">
              <div class="col-md-6 col-sm-12">
                <cap-kopfdatenelement label="Name">
                  {{ polGemeinde.name }}
                </cap-kopfdatenelement>
                <cap-kopfdatenelement label="bfsNummer">
                  {{ polGemeinde.bfsNummer }}
                </cap-kopfdatenelement>
              </div>
              <div class="col-md-6 col-sm-12">
                <cap-kopfdatenelement label="externeGemeinde">
                  {{ polGemeinde.extern | yesNo }}
                </cap-kopfdatenelement>
                <cap-kopfdatenelement label="kanton">
                  {{ polGemeinde.kanton }}
                </cap-kopfdatenelement>
              </div>
            </div>
          } @else {
            {{ "nichtDefiniert" | translate }}
          }
        </cap-rubrik>
      }
      <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrikGrundbuchamt">
        <ng-container title>
          <h2 class="mb-0">{{ "zustaendigesGrundbuchamt" | translate }}</h2>
        </ng-container>
        @if (grundbuchAmt$ | async; as grundbuchAmt) {
          <div class="row mt-2">
            <div class="col-md-6 col-sm-12">
              <cap-kopfdatenelement label="Name">
                {{ grundbuchAmt.name | translateName }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="Nummer">
                {{ grundbuchAmt.nummer }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="anschrift">
                @if (grundbuchAmt.name) {
                  <span>{{ grundbuchAmt.name | translateName }}<br /></span>
                }
                @if (grundbuchAmt.strasse) {
                  <span>{{ grundbuchAmt.strasse }}<br /></span>
                }
                @if (grundbuchAmt.ort) {
                  <span>{{ [grundbuchAmt.plz, grundbuchAmt.ort | translateName].filter(notEmpty).join(" ") }}</span>
                }
                <button
                  (click)="copyToClipboard(convertGrundbuchamtToAdress(grundbuchAmt))"
                  [ngbTooltip]="'AdresseKopieren' | translate"
                  class="btn py-0 copyBtn"
                  type="button">
                  <i class="far fa-copy"></i>
                </button>
              </cap-kopfdatenelement>
            </div>
            <div class="col-md-6 col-sm-12">
              <cap-kopfdatenelement label="email">
                {{ grundbuchAmt.emailadresse }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="telefonnummer1">
                {{ grundbuchAmt.telefonnummer1 }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="telefax">
                {{ grundbuchAmt.telefax }}
              </cap-kopfdatenelement>
            </div>
          </div>
        } @else {
          {{ "nichtDefiniert" | translate }}
        }
      </cap-rubrik>
      @if ((geometerBuero$ | async)?.nachfuehrungsGeometer && (geometerBuero$ | async); as geometer) {
        <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrikNachführungsgeometer">
          <ng-container title>
            <h2 class="mb-0">
              {{ "zustaendigerNachfuehrungsgeometer" | translate }}
            </h2>
          </ng-container>
          <div class="row mt-2">
            <div class="col-md-6 col-sm-12">
              <cap-kopfdatenelement label="Name">
                {{ geometer.name | translateName }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="anschrift">
                @if (geometer.name) {
                  <span>{{ geometer.name | translateName }}<br /></span>
                }
                @if (geometer.nachfuehrungsGeometer && geometer.nachfuehrungsGeometer.userName) {
                  <span>
                    {{ [geometer.nachfuehrungsGeometer.userName, geometer.nachfuehrungsGeometer.userVorname].filter(notEmpty).join(" ") }}
                    <br
                  /></span>
                }
                @if (geometer.strasse) {
                  <span>{{ geometer.strasse }}<br /></span>
                }
                @if (geometer.ort) {
                  <span>{{ [geometer.plz, geometer.ort | translateName].filter(notEmpty).join(" ") }}</span>
                }
                <button
                  (click)="copyToClipboard(convertGeometerbueroToAdress(geometer))"
                  [ngbTooltip]="'AdresseKopieren' | translate"
                  class="btn py-0 copyBtn"
                  type="button">
                  <i class="far fa-copy"></i>
                </button>
              </cap-kopfdatenelement>
            </div>
            <div class="col-md-6 col-sm-12">
              <cap-kopfdatenelement label="email">
                {{ geometer.emailAdresse }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="telefonnummer1">
                {{ geometer.telefonNummer1 }}
              </cap-kopfdatenelement>
              <cap-kopfdatenelement label="telefax">
                {{ geometer.telefaxNummer }}
              </cap-kopfdatenelement>
            </div>
          </div>
        </cap-rubrik>
      }
    </div>
  }

  <ng-template #nichtDefiniert>
    {{ "nichtDefiniert" | translate }}
  </ng-template>
</ng-container>
